import api from './authService';

export const adminCommissionService = {
  // Get all commission settings
  getAll: async (params = {}) => {
    const response = await api.get('/admin/commission-settings', { params });
    return response.data;
  },

  // Get default commission setting
  getDefault: async () => {
    const response = await api.get('/admin/commission-settings/default');
    return response.data;
  },

  // Get single commission setting
  getById: async (id) => {
    const response = await api.get(`/admin/commission-settings/${id}`);
    return response.data;
  },

  // Create commission setting
  create: async (data) => {
    const response = await api.post('/admin/commission-settings', data);
    return response.data;
  },

  // Update commission setting
  update: async (id, data) => {
    const response = await api.put(`/admin/commission-settings/${id}`, data);
    return response.data;
  },

  // Delete commission setting
  delete: async (id) => {
    const response = await api.delete(`/admin/commission-settings/${id}`);
    return response.data;
  },
};

